import React, {Component} from 'react';

import TextField from './TextField';

import './Summary.scss';

export default class Summary extends Component {
  render() {
    return (
      <div className="col-xs">
        <div className="row persona-summary">
          <div className="col-md">
            <TextField
              hideLabel={true}
              formKey="summary"
              {...this.props}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/Summary.jsx